export default __webpack_public_path__ + "static/media/instagram-24.c1497afe.svg";